import React from "react";

const Stage2 = (props) => {
  return <div>Stage 2</div>;
};

export default Stage2;
